import {
  node,
  string,
  number,
  arrayOf,
  element,
  objectOf,
  oneOfType,
} from 'prop-types';
import React from 'react';

import {
  StyledPanel,
  IconWrapper,
  StyledHeader,
  ContentWrapper,
} from 'components/Panel/Panel.styled';

/**
 * @param {{
 * icon: JSX,
 * children: JSX,
 * header: string,
 * minHeight: number,
 * }} param
 */
function Panel({ children, header, icon, minHeight }) {
  return (
    <StyledPanel minHeight={minHeight}>
      <ContentWrapper>
        <StyledHeader>{header}</StyledHeader>
        {children}
      </ContentWrapper>
      <IconWrapper>{icon}</IconWrapper>
    </StyledPanel>
  );
}

Panel.propTypes = {
  icon: node,
  header: string,
  minHeight: number,
  children: oneOfType([arrayOf(element), element, objectOf(element)]),
};

export default Panel;
